'use client';

import React, { useMemo } from 'react';
import { Badge, IconButton } from '@castlery/fortress';
import { ShoppingBag } from '@castlery/fortress/Icons';
import { useAppSelector } from '@castlery/shared-redux-store';
import { selectOrder, selectOrderLoading, selectWebMergeOrderLoading } from '@castlery/modules-order-domain';
import LinkButton from '../link-button/link-button';
import { EcEnv } from '@castlery/config';
// import { makePersistenceHandles } from '@castlery/shared-persistence-kit';

const ShoppingBagButton = () => {
  // const dispatch = useAppDispatch();
  const currentOrderData = useAppSelector(selectOrder);
  const orderLoadingStatus = useAppSelector(selectOrderLoading);
  const orderMergeLoadingStatus = useAppSelector(selectWebMergeOrderLoading);
  const cartItemNums = useMemo(() => {
    return currentOrderData?.line_items
      ? currentOrderData.line_items.reduce((accumulator, current) => {
          return accumulator + current?.quantity;
        }, 0)
      : 0;
  }, [currentOrderData?.line_items]);

  // useEffect(() => {
  //   dispatch(initShoppingBag());
  // }, [dispatch]);

  return (
    <IconButton
      size="md"
      component={LinkButton}
      path={`/${EcEnv.NEXT_PUBLIC_COUNTRY.toLocaleLowerCase()}/cart`}
      menu-type="user_menu"
      text="Account"
      sx={(theme) => ({
        padding: '0 !important',
        // minWidth: `${theme.spacing(6)} !important`,
        // minHeight: `${theme.spacing(6)} !important`,
        // padding: '0 !important',
        // maxWidth: `${theme.spacing(6)} !important`,
        // maxHeight: `${theme.spacing(6)} !important`,
      })}
    >
      <Badge
        loading={currentOrderData === null || orderLoadingStatus || orderMergeLoadingStatus}
        badgeContent={cartItemNums ?? null}
      >
        <ShoppingBag
          sx={(theme) => ({
            width: theme.spacing(6),
            height: theme.spacing(6),
            fill: theme.palette.brand.mono[900],
          })}
        />
      </Badge>
    </IconButton>
  );
};

export { ShoppingBagButton };
